import React, { useEffect, useState } from "react";

export default function CursorFollow() {
  const [pos, setPos] = useState({ x: -500, y: -500 });
  const [active, setActive] = useState(false);

  useEffect(() => {
    const handle = (e) => {
      setPos({ x: e.clientX, y: e.clientY });
      setActive(true);
    };
    const leave = () => setActive(false);
    window.addEventListener("mousemove", handle);
    window.addEventListener("mouseleave", leave);
    return () => {
      window.removeEventListener("mousemove", handle);
      window.removeEventListener("mouseleave", leave);
    };
  }, []);

  return (
    <div
      className="cursor-follow"
      style={{ left: pos.x, top: pos.y, opacity: active ? 1 : 0 }}
    />
  );
}
